var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "report-new" } },
    [
      _c(
        "AppBreadCrumb",
        {
          attrs: {
            paths: [{ title: _vm.$t("report.detailReport") }],
            select: true,
          },
        },
        [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.customDateFilter,
                  expression: "customDateFilter",
                },
              ],
              attrs: { id: "time-select" },
              on: {
                change: function ($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function (o) {
                      return o.selected
                    })
                    .map(function (o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.customDateFilter = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                },
              },
            },
            [
              _c("option", { attrs: { value: "today" } }, [
                _vm._v(_vm._s(_vm.$t("time.today"))),
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "yesterday" } }, [
                _vm._v(_vm._s(_vm.$t("time.yesterday"))),
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "current-week" } }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("time.currentWeek")) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "last-week" } }, [
                _vm._v(_vm._s(_vm.$t("time.lastWeek"))),
              ]),
              _vm._v(" "),
              _c("option", { attrs: { value: "current-month" } }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("time.currentMonth")) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _vm._l(_vm.getLast11Months(), function (m, i) {
                return _c("option", { key: i, domProps: { value: m.date } }, [
                  _vm._v(
                    "\n                " + _vm._s(m.name) + "\n            "
                  ),
                ])
              }),
              _vm._v(" "),
              _c("option", { attrs: { value: "custom" } }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("time.custom")) +
                    "\n            "
                ),
              ]),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "report-container" },
        [
          _c("ReportFilterTool", {
            model: {
              value: _vm.filters,
              callback: function ($$v) {
                _vm.filters = $$v
              },
              expression: "filters",
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "report-content" },
            [
              _c("ReportMenu", {
                attrs: {
                  loading: _vm.loading,
                  stats: _vm.stats,
                  "update-query-params": _vm.updateQueryParams,
                  "current-tab": _vm.currentTab,
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { ref: "chartContainer", staticClass: "chart-container" },
                [
                  _c(
                    "div",
                    { staticClass: "report-page-container" },
                    [
                      _vm.currentTab === _vm.ReportTabs.OVERALL
                        ? _c("Overall", { attrs: { filters: _vm.filters } })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentTab === _vm.ReportTabs.Calendar
                        ? _c("Calendar", { attrs: { filters: _vm.filters } })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentTab === _vm.ReportTabs.Mail
                        ? _c("Mail", { attrs: { filters: _vm.filters } })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentTab === _vm.ReportTabs.CHAT_DISTRIBUTIONS
                        ? _c("ChatDistributions", {
                            attrs: { filters: _vm.filters },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentTab === _vm.ReportTabs.AGENT_PERFORMANCE
                        ? _c("AgentPerformance", {
                            attrs: { filters: _vm.filters },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentTab === _vm.ReportTabs.AGENT_ACTIVITIES
                        ? _c("AgentActivitiesReport", {
                            attrs: { filters: _vm.filters },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentTab === _vm.ReportTabs.AGENT_WORK_TIME
                        ? _c("AgentWorktime", {
                            attrs: { filters: _vm.filters },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentTab === _vm.ReportTabs.CUSTOMER_SATISFACTION
                        ? _c("CustomerSatisfaction", {
                            attrs: { filters: _vm.filters },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentTab === _vm.ReportTabs.WEBSITE_ANALYSIS
                        ? _c("WebsiteAnalysisReport", {
                            attrs: { filters: _vm.filters },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentTab === _vm.ReportTabs.CHANNEL_BREAKDOWN
                        ? _c("ChannelBreakdown", {
                            attrs: { filters: _vm.filters },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentTab === _vm.ReportTabs.WHATSAPP_BUSINESS_API
                        ? _c("WabaAnalys", { attrs: { filters: _vm.filters } })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentTab === _vm.ReportTabs.Ticket
                        ? _c("Ticket", { attrs: { filters: _vm.filters } })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentTab === _vm.ReportTabs.TASK
                        ? _c("TaskOverall", { attrs: { filters: _vm.filters } })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentTab === _vm.ReportTabs.CONTACT_DISTRIBUTIONS
                        ? _c("ContactDistributions", {
                            attrs: { filters: _vm.filters },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }